export default {
  methods: {
    calABC2() {
      var e = document.ABC2Form.elements;
      var valid = true;

      for (var i = 2; i < 6; i++) {
        if (e[i].value == "") {
          valid = false;
          break;
        }
      }

      if (valid) {
        var a = parseFloat(e.hlength.value);
        var b = parseFloat(e.hwidth.value);
        var c = parseFloat(e.hthick.value) / 10 * parseFloat(e.hnumber.value);
        var factor = e[1].checked ? 3 : 2;
        var score = a * b * c / factor;
        document.ABC2Form.hscore.value = score.toFixed(0);
      }
    }

  },
  id: 'f36cdf43e4',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=ABC2><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>ABC/2</div></div></div><div class=page-content><form name=ABC2Form><div class=block-header>HEMORRHAGE SHAPE</div><div class=list><ul><li><label class="item-radio item-radio-icon-end item-content"><input type=radio name=shape value=0 checked=checked @change=calABC2()> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Round or Ellipsoid</div></div></label></li><li><label class="item-radio item-radio-icon-end item-content" @change=calABC2()><input type=radio name=shape value=1> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Irregular, Separated, or Multinodular</div></div></label></li></ul></div><div class=list><ul><li class=item-content><div class=item-inner><div class=item-title>Hemorrhage length (cm):</div><div class=item-input style=width:15%;><input name=hlength placeholder=enter&nbsp;&nbsp;&nbsp; type=number value="" style="text-align: right;" @input=calABC2()></div></div></li><li class=item-content><div class=item-inner><div class=item-title>Hemorrhage width (cm):</div><div class=item-input style=width:15%;><input name=hwidth placeholder=enter&nbsp;&nbsp;&nbsp; type=number value="" style="text-align: right;" @input=calABC2()></div></div></li><li class=item-content><div class=item-inner><div class=item-title>CT slice thickness (<i>mm</i>):</div><div class=item-input style=width:15%;><input name=hthick placeholder=enter&nbsp;&nbsp;&nbsp; type=number value="" style="text-align: right;" @input=calABC2()></div></div></li><li class=item-content><div class=item-inner><div class=item-title>Number of CT slides:</div><div class=item-input style=width:15%;><input name=hnumber placeholder=enter&nbsp;&nbsp;&nbsp; type=number value="" style="text-align: right;" @input=calABC2()></div></div></li><li class=accordion-item><a href=# class="item-content item-link"><div class=item-inner><div class=item-text>Note when counting slides...</div></div></a><div class=accordion-item-content><div class=block-footer>Slice with &ge;75% area of hemorrhage: counts as 1 slice; Slice with 25-75% area of hemorrhage: counts as 0.5 slices; Slice with &lt;25% area of hemorrhage: counts as 0 slices</div></div></li><li class=item-content><div class=item-inner><div class=item-title>ICH volume (cm<sup>3</sup> or ml):</div><div class=item-input style=width:15%;><input name=hscore placeholder="" type=number value="" style="text-align: right;"></div></div></li></ul></div></form></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};